<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <h5>Datos generales</h5>
        <b-form>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <b-form-group
                            label="Apellido Paterno:"
                            label-for="paterno">
                        <b-form-input id="paterno-1" type="text"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <b-form-group
                            label="Apellido Materno:"
                            label-for="materno">
                        <b-form-input id="materno-1" type="text"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <b-form-group
                            label="Nombre(s):"
                            label-for="nombre">
                        <b-form-input id="nombre" type="text"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <b-form-group
                            label="Fecha de Nacimiento:"
                            label-for="nacimiento">
                        <b-form-datepicker placeholder="" id="nacimiento" ></b-form-datepicker>
                    </b-form-group>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <b-form-group
                            label="Estado civil:"
                            label-for="estado">
                        <b-form-select id="estado" ></b-form-select>
                    </b-form-group>
                </div>
            </div>
            <hr>
            <h5>Datos del plan/convenio</h5>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <b-form-group
                            label="Compañia:"
                            label-for="compania">
                        <b-form-select id="conpania" ></b-form-select>
                    </b-form-group>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <b-form-group
                            label="Plan/Convenio:"
                            label-for="plan">
                        <b-form-select id="plan" ></b-form-select>
                    </b-form-group>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <b-form-group
                            label="Número de póliza:"
                            label-for="poliza">
                        <b-form-input id="poliza" type="number"></b-form-input>
                    </b-form-group>
                </div>
            </div>

                <fieldset>
                    <legend>Vigencia</legend>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <b-form-group
                                    label="Fecha inicio:"
                                    label-for="inicio">
                                <b-form-datepicker placeholder="" id="inicio" ></b-form-datepicker>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <b-form-group
                                    label="Fecha fin:"
                                    label-for="fin">
                                <b-form-datepicker placeholder="" id="fin" ></b-form-datepicker>
                            </b-form-group>
                        </div>
                    </div>
                </fieldset>

        </b-form>
    </div>
</template>

<script>
    export default {
        name: "altaPaciente",
        data:()=> ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
        }),
      created() {
        this.debug = this.$localStorageService.getDebug();
      }
    }
</script>

<style scoped>

</style>
